import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type MenuMetaPillVariant = 'default' | 'price' | 'popular'

type MenuMetaPillProps = {
  children: ReactNode
  variant?: MenuMetaPillVariant
  className?: string
}

const variantClasses: Record<MenuMetaPillVariant, string> = {
  default: 'bg-ink/[0.05] text-muted',
  price: 'gap-1 bg-primary/[0.08] text-primary',
  popular: 'gap-1 bg-rose-50 text-rose-600',
}

function HeartIcon({ className }: { className?: string }) {
  return (
    <svg className={cn('size-3 shrink-0', className)} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </svg>
  )
}

export function MenuMetaPill({ children, variant = 'default', className }: MenuMetaPillProps) {
  return (
    <span
      className={cn(
        'inline-flex w-fit items-center rounded-full px-2.5 py-0.5 font-sans text-[length:var(--menu-fs-xs)] font-semibold uppercase tracking-[0.14em]',
        variantClasses[variant],
        className,
      )}
    >
      {variant === 'popular' ? <HeartIcon /> : null}
      {children}
    </span>
  )
}
